export default __webpack_public_path__ + "static/media/README.bfef87fd.md";